// extracted by mini-css-extract-plugin
export default {"tabContainer":"TabContainer_tabContainer__btfYc"};